<template>
  <div class="category">
    <a-modal
      v-model:visible="visible"
      :title="`${mode == 'add' ? '新增' : '编辑'}KEY值`"
      @ok="handleOk"
      @cancel="cancel"
    >
      <a-form
        :rules="rules"
        layout="vertical"
        class="small"
        ref="blockForm"
        :model="formState"
      >
        <a-form-item
          label="KEY值"
          name="itemKey"
          v-bind="validateInfos.itemKey"
        >
          <a-input
            v-model:value.trim="formState.itemKey"
            placeholder="请输入KEY值"
          />
        </a-form-item>
        <a-form-item
          label="页面示例："
          name="pageUrl"
          v-bind="validateInfos.pageUrl"
        >
          <UploadImg
            :bannerItem="{ defaultUrl: formState.pageUrl }"
            @addImg="setUrl"
          ></UploadImg>
        </a-form-item>
        <a-form-item
          label="基础语言："
          name="defaultValue"
          v-bind="validateInfos.defaultValue"
        >
          <a-input
            v-model:value="formState.defaultValue"
            placeholder="请输入基础语言"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script setup>
import UploadImg from './UploadImg.vue'
import { defineExpose, ref, reactive, defineProps, defineEmits } from 'vue'
import useAPI from 'UseApi'
import { Form } from 'ant-design-vue'
const useForm = Form.useForm
const { i18n_key_addOrUpdate_post_ } = useAPI(null, [8997])
const rules = reactive({
  itemKey: [{ required: true, message: 'KEY值不能为空' }],
  pageUrl: [{ required: true, message: '页面示例并不能为空' }],
  defaultValue: [{ required: true, message: '基础语言并不能为空' }]
})

const formState = reactive({
  itemKey: '',
  pageUrl: '',
  defaultValue: ''
})

const blockForm = ref(null)
const visible = ref(false)

const mode = ref('add')

const { resetFields, validate, validateInfos } = useForm(formState, rules, {})

const open = item => {
  Object.assign(formState, item)
  console.log(item.opera)
  if (item.opera === 'update') {
    mode.value = 'update'
  }
  if (item.opera === 'add') {
    mode.value = 'add'
    delete formState.id
  }
  visible.value = !visible.value
}

const handleOk = async () => {
  await validate()
  await addOrUpdateKey()
  emit('initList')
  visible.value = false
  cancel()
}
const addOrUpdateKey = async () => {
  await i18n_key_addOrUpdate_post_({
    ...formState,
    categoryId: props.categoryId
  })
}
const cancel = () => {
  resetFields()
}
const setUrl = url => {
  formState.pageUrl = url
}

const props = defineProps({
  categoryId: [String, Number]
})
console.log('categoryId', props.categoryId)

const emit = defineEmits(['initList'])

defineExpose({ open })
</script>
